import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto relative rounded-2xl overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20gradient%20with%20golden%20and%20cream%20tones%2C%20soft%20flowing%20organic%20shapes%2C%20minimalist%20elegant%20background%2C%20subtle%20light%20patterns%2C%20professional%20and%20inviting%20atmosphere%2C%20no%20text&width=1200&height=600&seq=cta-17c-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 to-foreground-900/40"></div>
        </div>

        <div className="relative z-10 px-8 md:px-14 py-14 md:py-16 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
            立即访问 17c 平台
          </h2>
          <p className="text-sm md:text-base text-background-200/80 max-w-xl mx-auto mb-8 leading-relaxed">
            在浏览器地址栏输入 http //www.17c/，即刻体验便捷高效的数字化服务。新用户注册即可享受完整功能体验。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/article/register-login"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-medium text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
            >
              立即注册
              <i className="ri-user-add-line ml-2"></i>
            </Link>
            <Link
              to="/category/guide"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm text-background-100 font-medium text-base border border-background-50/30 hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap text-center"
            >
              查看使用教程
              <i className="ri-play-circle-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}